import React, { useState } from "react"
import style from "./mailchimp.module.scss"
import MailchimpSubscribe from "react-mailchimp-subscribe"
import {Link} from "gatsby";


function Mailchimp() {
    const url = "https://acuboston.us11.list-manage.com/subscribe/post?u=c8f3e8413d5a1d3ed2ce0854a&id=b87c4db0d2&f_id=006f90e0f0";
    // simplest form (only email)
    const SimpleForm = () => <MailchimpSubscribe url={url}/>
    return (
        <div className={`${style.mailchimp} container`} id="mailchimp">
            <h2 className={style.mailchimp__title}>Sign up for Newsletter</h2>
                <div className={style.mailchimp__other}>
        <MailchimpSubscribe
            url={url}
            render={({ subscribe, status, message }) => (
                <div className={style.mailchimpForm}>
                    <SimpleForm onSubmitted={formData => subscribe(formData)} />
                    {status === "sending" && <div style={{ color: "blue" }}>sending...</div>}
                    {status === "error" && <div style={{ color: "red" }} dangerouslySetInnerHTML={{__html: message}}/>}
                    {status === "success" && <div style={{ color: "green" }}>Subscribed !</div>}
                </div>
            )}
        />
                </div>

            Previous newsletters:
            <ul>
                <li><Link to={'/newsletters/february-newsletter.html'}>2024 February Newsletter</Link></li>
                <li><Link to={'/newsletters/december-newsletter.html'}>2023 December Newsletter</Link></li>
                <li><Link to={'/newsletters/november-newsletter.html'}>2023 November Newsletter</Link></li>
                <li><Link to={'/newsletters/october-newsletter.html'}>2023 October Newsletter</Link></li>
                <li><Link to={'/newsletters/june-newsletter.html'}>2023 June Newsletter</Link></li>
                <li><Link to={'/newsletters/spring-newsletter.html'}>2023 Spring Newsletter</Link></li>
            </ul>
        </div>
    )
}

export default Mailchimp